export const TOGGLE_SIDEBAR = 'Layout/TOGGLE_SIDEBAR';

export const toggleSidebar = () => ({
  type: TOGGLE_SIDEBAR,
});
